import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { getUserInfo, updateUser } from "../../helper/userHelper";
import { getDeviceReading, updateDevice } from "../../helper/deviceHelper";
import { useLocation, useNavigate } from 'react-router-dom';
import { DeviceCalibrationProps } from '../../interfaces'

const PHCalibrationForm = ({device}:DeviceCalibrationProps) => {
    const { user } = useAuthContext();
    const [beginState, setBeginState] = useState<boolean>(false)
    const [stepOneState, setStepOneState] = useState<boolean>(false)
    const [stepTwoState, setStepTwoState] = useState<boolean>(false)
    const [stepThreeState, setStepThreeState] = useState<boolean>(false)
    const [currentReading, setCurrentReading] = useState<string>('')
    const location = useLocation();
    const navigate = useNavigate();

    const getLatestReading = async() =>{
        if(user){
            const response = await getDeviceReading(user, device.device_id);
            if(response.reading != '--'){
                setCurrentReading(response.reading);
            }
        }
    }

    const refreshComponent = () => {
        navigate(location.pathname);
      }

    const handleError = () =>{
        if(user){
            setBeginState(false)
            setStepOneState(false)
            setStepTwoState(false)
            setStepThreeState(false)
            user.calibrate_device = false;
            user.device_to_calibrate = ""
            user.calibration_incoming_message = ""
            user.calibration_outgoing_message = ""
        }
    }



    useEffect(() => {
        let intervalId: ReturnType<typeof setInterval> | undefined;

        if (beginState) {
            intervalId = setInterval(() => {
                void getLatestReading();
            }, 1000);
        }

        return () => {
            if (intervalId !== undefined) clearInterval(intervalId);
        };
    }, [beginState]);


    const midCalibration = async() => {
        // user.calibrate_device = true
        // user.device_to_calibrate = device.device_id
        if(user) user.calibration_outgoing_message = "Mid";
        const response = await updateUser(user);
        if(response.ok){
            let counter = 0;
            const intervalId = setInterval(function() {
            void (async () => {
            counter++;
            /** Poll with GET — PATCH updateUser would overwrite incoming_message written by DeviceController. */
            const poll = await getUserInfo(user);
            const user_calibration_data = await poll.json() as { calibration_incoming_message?: string };
            if (user && typeof user_calibration_data.calibration_incoming_message === 'string') {
                user.calibration_incoming_message = user_calibration_data.calibration_incoming_message;
            }
            if(user_calibration_data.calibration_incoming_message === 'Calibrated Mid'){
                setStepOneState(true)
                console.log("calibrated Mid!")
                clearInterval(intervalId);
            }
            if(user_calibration_data.calibration_incoming_message === 'Error with Mid'){
                clearInterval(intervalId);
            }
            if (counter === 15) {
                clearInterval(intervalId);
            }
            })();
            }, 2000);
        }
    }
    const lowCalibration = async() => {
        // user.calibrate_device = true
        // user.device_to_calibrate = device.device_id
        console.log('started low calibration')
        if(user) user.calibration_outgoing_message = "Low";
        const response = await updateUser(user);
        if(response.ok){
            let counter = 0;
            const intervalId = setInterval(function() {
            void (async () => {
            counter++;
            const poll = await getUserInfo(user);
            const user_calibration_data = await poll.json() as { calibration_incoming_message?: string };
            if (user && typeof user_calibration_data.calibration_incoming_message === 'string') {
                user.calibration_incoming_message = user_calibration_data.calibration_incoming_message;
            }
            if(user_calibration_data.calibration_incoming_message === 'Calibrated Low'){
                setStepTwoState(true)
                setStepOneState(false)
                console.log("calibrated Low!")
                clearInterval(intervalId);
            }
            if(user_calibration_data.calibration_incoming_message === 'Error with Low'){
                setStepTwoState(true)
                setStepOneState(false)
                console.log("calibrated Low!")
                clearInterval(intervalId);
            }
            if (counter === 15) {
                clearInterval(intervalId);
            }
            })();
            }, 2000);
        }
    }

    const highCalibration = async() => {
        // user.calibrate_device = true
        // user.device_to_calibrate = device.device_id
        console.log('started high calibration')
        if(user){
            user.calibration_outgoing_message = "High"
            const response = await updateUser(user);
            if(response.ok){
                let counter = 0;
                const intervalId = setInterval(function() {
                void (async () => {
                counter++;
                const poll = await getUserInfo(user);
                const user_calibration_data = await poll.json() as { calibration_incoming_message?: string };
                if (user && typeof user_calibration_data.calibration_incoming_message === 'string') {
                    user.calibration_incoming_message = user_calibration_data.calibration_incoming_message;
                }
                if(user_calibration_data.calibration_incoming_message === 'Calibrated High'){
                    setStepThreeState(true)
                    setStepTwoState(false)
                    console.log("calibrated High!")
                    clearInterval(intervalId);
                    user.calibrate_device = false;
                    user.device_to_calibrate = ""
                    user.calibration_incoming_message = ""
                    user.calibration_outgoing_message = ""
                    void updateUser(user);
                    device.calibrated = true
                    if((device instanceof Object && 'last_calibrated' in device))device.last_calibrated = new Date();
                    void updateDevice(user, device)
                    refreshComponent()
                }
                if(user_calibration_data.calibration_incoming_message === 'Error with High'){
                    clearInterval(intervalId);
                }
                if (counter === 15) {
                    clearInterval(intervalId);
                }
                })();
                }, 2000);
            }
        }
    }

    const beginCalibration = async() => {
        if(user){
            user.calibrate_device = true
            user.device_to_calibrate = device.device_id
            user.calibration_outgoing_message = "Begin"
            const response = await updateUser(user);
            if(response.ok){
                console.log("Started Calibration!")
            }
        }
    }



    

    return ( 
        <>
        <h3>Calibrating {device.device_type} </h3>
        <p>The calibration process is a 3 step procedure. First we calibrate the sensor to the mid-point(pH 7),
            then the low point (pH 4), then lastly the high point (pH 10). It's important to follow this order in order to successfully
            calibrate the sensor.
        </p>
        <button onClick={(e) => {
            e.preventDefault();
            console.log("Begin Calibration")
            setBeginState(!beginState);
            beginCalibration();
        }}>Begin</button>
        <br />
        {(beginState && !stepOneState && !stepTwoState && !stepThreeState) && <>
        <label>Step 1: Mid-Point Calibration</label>
        <ol>
            <li>First Remove the cover cap from the probe and rinse the probe with water.</li>
            <li>Gently shake the probe to remove excess water</li>
            <li>Remove the top of the pH 7 calibration solution pouch, then place the probe inside.</li>
            <li>Wait for the readings to stabilize below (small movements from one reading to the next is normal) and the press the "Okay" button.
                Note: This may take 1-2 minutes.
            </li>
            <li>Wait for the reading to say "Calibrated Mid" before moving onto the next step.</li>
        </ol>
        Reading: {currentReading}

        <button onClick={(e) => {
            e.preventDefault();
            midCalibration()
        }}>Okay</button>
        </>}

        <br/>
       {(stepOneState && !stepTwoState && !stepThreeState) && 
       <>
        <label>Step 2: Low-Point Calibration</label>
        <ol>
            <li>Remove the probe from the previous solution and rinse it off with water. </li>
            <li>Gently shake the probe to remove excess water</li>
            <li>Remove the top of the pH 4 calibration solution pouch, then place the probe inside.</li>
            <li>Wait for reading to stabilize (1-2 minutes)</li>
            <li>Press the "Okay" button when readings stabilize</li>
            <li>Wait for the reading to say "Calibrated Low" before moving onto the next step.</li>
        </ol>
        Reading: {currentReading}
        <button onClick={(e) => {
            e.preventDefault();
            lowCalibration()
        }}>Okay</button>
        </>}
        {(stepTwoState && !stepOneState && !stepThreeState) && 
       <>
        <label>Step 3:</label>
        <ol>
            <li>Remove the probe from the previous solution and rinse it off with water. </li>
            <li>Gently shake the probe to remove excess water</li>
            <li>Remove the top of the pH 10 calibration solution pouch, then place the probe inside.</li>
            <li>Wait for reading to stabilize (1-2 minutes)</li>
            <li>Press the "Okay" button when readings stabilize</li>
            <li>Once the reading says "Calibrated High" your device if finally calibrated.</li>
        </ol>
        Reading: {currentReading}
        <button onClick={(e) => {
            e.preventDefault();
            highCalibration()
        }}>Okay</button>
        </>}
        {stepThreeState && <>
        Calibrated Successfully!!!!
        </>}

        </>
     );
}
 
export default PHCalibrationForm;